document.addEventListener('DOMContentLoaded', () => {
  const ZOOM_SCALE = 1.5;   // change for more/less zoom

  // Grab the gallery viewer (where slides live)
  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;
  const viewer  = gallery.querySelector('[id^="GalleryViewer"]');
  if (!viewer)  return;

  // Keep track of the current active media container
  let activeContainer = null;
  function updateActive() {
    activeContainer = viewer.querySelector('li.product__media-item.is-active .product__media');
  }

  // Initial, and whenever a slide changes via your slider
  updateActive();
  viewer.addEventListener('slideChanged', updateActive);

  // If you’re also swapping slides by clicking thumbnails via setActiveMedia(),
  // you can trigger the same custom event at end of that method:
  //   this.viewer.dispatchEvent(new Event('slideChanged'));
  //
  // Or we can observe class changes:
  const observer = new MutationObserver(muts => {
    for (let m of muts) {
      if (m.attributeName === 'class' && m.target.classList.contains('is-active')) {
        updateActive();
        break;
      }
    }
  });
  viewer.querySelectorAll('li.product__media-item').forEach(li => {
    observer.observe(li, { attributes: true, attributeFilter: ['class'] });
  });

  // On mousemove over the viewer, if it’s inside the active container, zoom under cursor:
  viewer.addEventListener('mousemove', e => {
    if (!activeContainer) return;
    if (!activeContainer.contains(e.target)) return;

    const img = activeContainer.querySelector('img');
    if (!img) return;

    const rect = activeContainer.getBoundingClientRect();
    const xPct = ((e.clientX - rect.left) / rect.width)  * 100;
    const yPct = ((e.clientY - rect.top)  / rect.height) * 100;

    img.style.transformOrigin = `${xPct}% ${yPct}%`;
    img.style.transform       = `scale(${ZOOM_SCALE})`;
  });

  // Reset on mouseleave of the active container
  viewer.addEventListener('mouseout', e => {
    if (!activeContainer || !activeContainer.contains(e.relatedTarget)) {
      // if moving out of the active container entirely
      const img = activeContainer?.querySelector('img');
      if (img) img.style.transform = 'scale(1)';
    }
  });
});
